import { Button, Popover, Tag, Typography } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { getDocumentAuditMeta } from "../../utils/documentAudit";

const { Text } = Typography;

interface DocumentAuditMetaBlockProps {
  document: any;
}

/** Shared P0-04 audit lines for member / claim document cards. */
const DocumentAuditMetaBlock: React.FC<DocumentAuditMetaBlockProps> = ({
  document,
}) => {
  const audit = getDocumentAuditMeta(document);

  const byLine = audit.hasUploader
    ? `${audit.uploaderName}${
        audit.uploaderRole ? ` (${audit.uploaderRole})` : ""
      }`
    : "Uploader unknown";

  const popoverContent = (
    <div className="document-audit-popover">
      {audit.documentTypeLabel && (
        <div className="document-audit-popover-row">
          <Text type="secondary">Type</Text>
          <Text>{audit.documentTypeLabel}</Text>
        </div>
      )}
      {audit.id != null && (
        <div className="document-audit-popover-row">
          <Text type="secondary">Reference</Text>
          <Text className="document-audit-popover-value" title={String(audit.id)}>
            {String(audit.id)}
          </Text>
        </div>
      )}
      {audit.uploadedAtLabel && (
        <div className="document-audit-popover-row">
          <Text type="secondary">When</Text>
          <Text>{audit.uploadedAtLabel}</Text>
        </div>
      )}
      <div className="document-audit-popover-row">
        <Text type="secondary">By</Text>
        <Text>{byLine}</Text>
      </div>
    </div>
  );

  return (
    <>
      <Popover
        content={popoverContent}
        title="Upload details"
        trigger="click"
        placement="bottomRight"
      >
        <Button
          type="text"
          size="small"
          className="document-audit-info-btn"
          icon={<InfoCircleOutlined />}
          aria-label="Upload details"
          onClick={(e) => e.stopPropagation()}
        />
      </Popover>
      {audit.source && (
        <div className="document-audit-meta">
          <Tag color="blue">{audit.source}</Tag>
        </div>
      )}
    </>
  );
};

export default DocumentAuditMetaBlock;
